export const iconFontAwesomeSocialCakeCandles = (
	<i className="fa-solid fa-cake-candles"></i>
);
